import { Label } from '@fluentui/react';
import React from 'react';
import ArcSelectorLine from './ArcSelectorLine';

const ArcSelector = (props) => {
    const selectList = Array.isArray(props.data) ? props.data : [];

    const label =
        props.config.Label === undefined ? null : (
            <Label>{props.config.Label}</Label>
        );

    return (
        <>
            {label}
            {selectList.map((data) => (
                <ArcSelectorLine
                    config={props.config}
                    data={data}
                    enableClick={props.enableClick}
                    menuClick={props.menuClick}
                    columnClick={props.columnClick}
                    language={props.language}
                ></ArcSelectorLine>
            ))}
        </>
    );
};

export default ArcSelector;
